<template>
  <div
    class="min-h-screen h-full audifonts__audi-type"
    :class="$style['layout-color']">
    <div
      v-if="loading"
      class="flex items-center min-h-screen h-full">
      <XSpinner class="text-4xl" />
    </div>

    <div
      v-else
      class="mx-auto"
      :class="$style['layout-size']">
      <div
        v-if="!event.isTimelinePublished"
        class="text-center text-black font-medium py-4">
        {{ $t('event.timeline.unpublish') }}
      </div>

      <div class="mb-8">
        <div class="relative flex items-center justify-center">
          <img
            :class="$style['header-image']"
            :src="headerImage">
        </div>
      </div>

      <div v-if="errorMessage">
        {{ errorMessage }}
      </div>

      <div
        v-else
        class="mx-auto max-w-md h-full px-4">
        <XShow :reaction="reaction" />
      </div>

      <div
        v-if="event.timeline.template.footer.enabled"
        class="mt-10 py-4">
        <div class="inline-flex w-full items-center justify-center">
          <div
            v-for="(social, index) in timelineTemplate.footer.socials"
            :key="index"
            class="inline-block"
            :class="{ 'mr-6': index + 1 < timelineTemplate.footer.socials.length }">
            <a
              :href="social.link"
              target="_blank"
              class="no-underline">
              <img
                :src="social.image"
                class="w-auto h-auto"
                :class="$style['footer-image']"
                alt="Social icon">
            </a>
          </div>
        </div>
      </div>

      <div
        v-if="timelineTemplate.terms.enabled"
        class="py-3 px-4">
        <div
          class="py-2 px-3 quill-class"
          v-html="timelineTemplate.terms.content" />
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapState } from 'vuex'
import _ from 'lodash'

import XShow from './Index'

export default {
  components: {
    XShow
  },

  data () {
    return {
      configTemplate: {},
      errorMessage: '',
      event: {},
      reaction: {},
      isDesktop: false
    }
  },

  computed: {
    ...mapState({
      eventId: state => state.routeParameters.event.id,
      reactionId: state => state.routeParameters.reaction.id
    }),

    loading () {
      return this.$apollo.queries.event.loading || this.$apollo.queries.reaction.loading
    },

    timelineTemplate () {
      return this.event.timeline ? this.event.timeline.template : {}
    },

    headerImage () {
      let mobileHeader = this.timelineTemplate.headerImageMobile
        ? this.timelineTemplate.headerImageMobile
        : this.timelineTemplate.headerImageDesktop

      return this.isDesktop
        ? this.timelineTemplate.headerImageDesktop
        : mobileHeader
    }
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    onResize: _.throttle(function () {
      this.isDesktop = window.innerWidth > 668
    }, 300)
  },

  apollo: {
    event: {
      query: gql`query ($eventId: Uuid!) {
        event (eventId: $eventId) {
          id
          isTimelinePublished
          timeline {
            template {
              headerImageDesktop
              headerImageMobile
              footer {
                enabled
                socials {
                  link
                  image
                }
              }
              terms {
                enabled
                content
              }
            }
          }
        }
      }`,
      variables () {
        return {
          eventId: this.eventId
        }
      },
      update (result) {
        return result.event
      },
      error (error) {
        if (error.graphQLErrors && error.graphQLErrors.length !== 0) {
          this.errorMessage = error.graphQLErrors[0].message
        } else {
          this.errorMessage = this.$t('common.notifications.messages.requestError')
        }
      }
    },

    reaction: {
      query: gql`query ($eventId: Uuid!, $reactionId: Uuid!) {
        event (eventId: $eventId) {
          reaction (reactionId: $reactionId) {
            id
            type
            url
            data
            createdAt
          }
        }
      }`,
      variables () {
        return {
          eventId: this.eventId,
          reactionId: this.reactionId
        }
      },
      update (result) {
        return result.event.reaction
      },
      error (error) {
        if (error.graphQLErrors && error.graphQLErrors.length !== 0) {
          this.errorMessage = error.graphQLErrors[0].message
        } else {
          this.errorMessage = this.$t('common.notifications.messages.requestError')
        }
      }
    }
  }
}
</script>

<style lang="scss" module>
.header-image {
  display: block;
  max-width: 100%;
  max-height: 400px;
  margin: 0 auto;
}

.layout-size {
  max-width: 1800px;
}

.layout-color {
  background-color: #fafafa;
}

.terms {
  p {
    line-height: 1;
  }
}
</style>

<style lang="scss">
.quill-class {
  strong {
    font-weight: 700;
  }
}
</style>
